/* ═══════════════════════════════════════════════
   Jessica Nails — Tratamientos JS
   Archivo: assets/jessica-tratamientos.js
   ═══════════════════════════════════════════════ */

(function() {

let currentProd = null;
let currentSizeIdx = 0;

window.jtOpenModal = function(idx) {
  const p = window.jtProdsData.find(x => x.idx === idx);
  if (!p) return;
  currentProd = p;
  currentSizeIdx = 0;

  document.getElementById('jtMCode').textContent = p.code;
  document.getElementById('jtMName').textContent = p.name;
  document.getElementById('jtMCat').textContent = p.cat;
  document.getElementById('jtMDesc').textContent = p.descLong || p.desc;

  const sizesEl = document.getElementById('jtMSizes');
  const sizes = (p.sizes || []).filter(s => s.label && s.price > 0);
  if (sizes.length > 1) {
    sizesEl.innerHTML = sizes.map((s, j) =>
      `<button class="jt-size-btn${j === 0 ? ' active' : ''}" onclick="jtSelectSize(${j})">${s.label} — $${s.price.toLocaleString()}</button>`
    ).join('');
    document.getElementById('jtMPrice').textContent = '$' + sizes[0].price.toLocaleString() + '.00';
  } else if (sizes.length === 1) {
    sizesEl.innerHTML = `<button class="jt-size-btn active">${sizes[0].label} — $${sizes[0].price.toLocaleString()}</button>`;
    document.getElementById('jtMPrice').textContent = '$' + sizes[0].price.toLocaleString() + '.00';
  } else {
    sizesEl.innerHTML = '';
    document.getElementById('jtMPrice').textContent = '$' + p.price.toLocaleString() + '.00';
  }

  const imgs = [p.img1, p.img2, p.img3].filter(Boolean);
  const mMain = document.getElementById('jtMMain');
  const mThumbs = document.getElementById('jtMThumbs');

  function show(i) {
    if (imgs[i]) {
      mMain.innerHTML = `<img src="${imgs[i]}" alt="${p.name}">`;
    } else {
      mMain.innerHTML = `<span style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:#bbb;">${p.code}</span>`;
    }
    mThumbs.querySelectorAll('.jt-modal__thumb').forEach((t, j) => t.classList.toggle('sel', j === i));
  }

  if (imgs.length > 0) {
    mThumbs.innerHTML = imgs.map((src, i) =>
      `<div class="jt-modal__thumb${i === 0 ? ' sel' : ''}" onclick="jtShowImg(${i})">
        <img src="${src}" alt="">
      </div>`
    ).join('');
    show(0);
  } else {
    mMain.innerHTML = `<span style="font-size:9px;letter-spacing:.1em;text-transform:uppercase;color:#bbb;">${p.code}</span>`;
    mThumbs.innerHTML = '';
  }

  window.jtShowImg = show;
  document.getElementById('jt-modal').classList.add('open');
};

window.jtSelectSize = function(j) {
  if (!currentProd) return;
  currentSizeIdx = j;
  const sizes = (currentProd.sizes || []).filter(s => s.label);
  document.getElementById('jtMPrice').textContent = '$' + sizes[j].price.toLocaleString() + '.00';
  document.querySelectorAll('.jt-size-btn').forEach((b, k) => b.classList.toggle('active', k === j));
};

window.jtCloseModal = function(e) {
  if (e.target === document.getElementById('jt-modal')) {
    document.getElementById('jt-modal').classList.remove('open');
  }
};

window.jtAddToCart = function() {
  if (!currentProd) return;
  const sizes = (currentProd.sizes || []).filter(s => s.label);
  const size = sizes[currentSizeIdx];
  const key = currentProd.code + '_' + (size ? size.label : 'único');
  const name = currentProd.name + (size ? ' ' + size.label : '');
  const price = size ? size.price : currentProd.price;
  if (window.jnCart) {
    window.jnCart.toggle({ key, code: currentProd.code, name, price, color: '#1D9E75', type: 'trat' });
    window.jnCart.open();
  }
};

})();
